module.exports = __webpack_public_path__ + "static/media/protein.652a5ff8.svg";